/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="none"
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="1.5"
    d="M11.017 2.814a1.002 1.002 0 0 1 .3441-.586A1 1 0 0 1 12 1.998c.2334 0 .4594.081.6389.23s.3013.357.3441.586l1.051 5.558a2 2 0 0 0 .551 1.043c.2844.284.6479.476 1.043.551l5.558 1.051c.2294.043.4366.165.5857.344.1491.18.2307.406.2307.639s-.0816.459-.2307.639a1.003 1.003 0 0 1-.5857.344l-5.558 1.051a2.006 2.006 0 0 0-1.043.551 2 2 0 0 0-.551 1.043l-1.051 5.558a1.002 1.002 0 0 1-.3441.586 1 1 0 0 1-.6389.23 1 1 0 0 1-.6389-.23 1.002 1.002 0 0 1-.3441-.586l-1.051-5.558a1.999 1.999 0 0 0-1.594-1.594l-5.558-1.051a1.003 1.003 0 0 1-.5857-.344A1.002 1.002 0 0 1 1.9976 12c0-.233.0816-.459.2307-.639.1491-.179.3563-.301.5857-.344l5.558-1.051a1.9993 1.9993 0 0 0 1.594-1.594zM20 2v4M22 4h-4M4 22c1.1046 0 2-.895 2-2s-.8954-2-2-2-2 .895-2 2 .8954 2 2 2"
  />,
  'Sparkles'
);
